// fontSizes.js or fontSizes.ts
const fontSizes = {
  xss: "10px",
  xs: "12px", // Extra small
  sm: "14px", // Small
  md: "16px", // Medium (default)
  lg: "18px", // Large
  xl: "20px", // Extra large
  "2xl": "24px", // Extra large
  "3xl": "28px", // Extra large
  "4xl": "30px",
  "5xl": "40px", // Extra large
  banner_heading: "56px",
};

export default fontSizes;
